/**
 * L1 — Full Screen Visual
 * Image/video fills the entire frame.
 * Headline overlays at the bottom with a dark gradient.
 */
import React from 'react';
import { AbsoluteFill } from 'remotion';
import type { SceneProps } from '../../types';
import {
  SceneContainer, Visual, HeadlineText, SubheadlineText,
  GlobalOverlays, AccentBar,
} from './shared';

export const L1_FullScreenVisual: React.FC<SceneProps> = (props) => {
  const { headline, subheadline, assets, colorPalette, headlineFont, subheadlineFont } = props;
  const primary = assets.primary ?? assets.video;

  return (
    <SceneContainer bg={colorPalette.background}>
      {/* Full-screen visual with Ken Burns */}
      <AbsoluteFill>
        <Visual asset={primary} kenBurns kenBurnsDirection="in" layerKey="primaryMedia" />
      </AbsoluteFill>

      {/* Gradient overlay — darkens bottom for text legibility */}
      <AbsoluteFill style={{
        background: 'linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.3) 45%, transparent 100%)',
      }} />

      {/* Headline + subheadline at bottom */}
      <AbsoluteFill style={{
        display: 'flex', flexDirection: 'column', justifyContent: 'flex-end',
        padding: '0 80px 110px',
      }}>
        <AccentBar color={colorPalette.accent} style={{ marginBottom: 14 }} />
        <HeadlineText
          text={headline}
          font={{ ...headlineFont, color: '#fff', fontSize: Math.min(headlineFont.fontSize, 56) }}
          delay={6}
          layerKey="headline"
        />
        {subheadline && (
          <SubheadlineText
            text={subheadline}
            font={{ ...subheadlineFont, color: 'rgba(255,255,255,0.8)' }}
            delay={18}
            style={{ marginTop: 10 }}
            layerKey="subheadline"
          />
        )}
      </AbsoluteFill>

      {/* Global overlays */}
      <GlobalOverlays props={props} />
    </SceneContainer>
  );
};
